import React, { useState, useEffect } from "react";
//import DateTimePicker from 'react-datetime-picker';
import { CDBBtn } from "cdbreact";
import Select from "react-select";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import dayjs from "dayjs";
import { da } from "date-fns/locale";

export const ModalDispatchOrders = ({
  action,
  setPressedButton,
  formData,
  handleChange,
  providers,
}) => {
  function isResolution1366x768() {
    return window.screen.width === 1366 && window.screen.height === 768;
  }

  const providerSelect = providers.map((provider) => ({
    value: provider.Nit,
    label: `Código Proveedor: ${provider.Nit} / Nombre del proyecto: ${provider.ProjectName}`,
  }));

  return (
    <div>
      <div className="modal-header">
        <div>
          <h3 className="modal-title" id="exampleModalLabel">
            {action === "create" ? "Crear un despacho" : "Editando despacho"}
          </h3>
        </div>
        {action === "edit" ? (
          <CDBBtn
            size="small"
            className="p-2 btn"
            color="danger"
            outline
            onClick={() => {
              setPressedButton("delete");
            }}
          >
            <i className="fas fa-trash"></i>
            Eliminar Despacho
          </CDBBtn>
        ) : null}
      </div>
      <div className="modal-body">
        {action !== "create" ? (
          <div className="form-group">
            <label>ID de despacho:</label>
            <input
              type="text"
              className="form-control mb-4"
              id="IDDispatch"
              placeholder="ID de despacho..."
              value={formData.IDDispatch}
              disabled
              onChange={handleChange}
            />
          </div>
        ) : null}
        {action !== "edit" ? (
          <div className="form-group">
            <label>
              ID de despacho:<span className="text-danger"> *</span>
            </label>
            <input
              type="text"
              className="form-control mb-4"
              id="IDDispatch"
              placeholder="ID de despacho..."
              value={formData.IDDispatch}
              onChange={(e) =>
                handleChange([{ id: "IDDispatch", value: e.target.value }])
              }
            />
          </div>
        ) : null}

        <div className="form-group row mb-4">
          <div className="col">
            <label htmlFor="selectCodeSap">Código Proveedor:</label>
            <Select
              id="selectCodeSap"
              placeholder="Seleccione un código de proveedor"
              isDisabled={action === "edit"}
              options={providerSelect}
              value={providerSelect.find(
                (option) =>
                  option.value === formData.Nit
              )}
              onChange={(selectedOption) => {
                handleChange([
                  {
                    value: selectedOption.value,
                    id: "Nit",
                  },
                ]);
                // handleChange({
                //   target: {
                //     value: selectedOption.value,
                //     id: "CodeSap",
                //   },
                // })
              }}
            />
          </div>
        </div>

        <div style={{ overflowY: "hidden" }}>
          <label htmlFor="Inventory">Tiempo de entrega estimado:</label>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
          {isResolution1366x768() ? (
  <MobileDateTimePicker
    className="form-control mb-4"
    id="DeliveryTime"
    value={dayjs(formData.DeliveryTime)}
    onChange={(date) =>
      handleChange([{ id: "DeliveryTime", value: date }])
    }
  />
) : (
  <DateTimePicker
    className="form-control mb-4"
    id="DeliveryTime"
    value={dayjs(formData.DeliveryTime)}
    onChange={(date) =>
      handleChange([{ id: "DeliveryTime", value: date }])
    }
  />
)}
          </LocalizationProvider>
        </div>

        <div className="form-group">
          <label htmlFor="DispatchDescription">
            Observaciones del despacho:
          </label>
          <textarea
            className="form-control mb-4"
            id="DispatchDescription"
            placeholder="Observaciones..."
            value={formData.DispatchDescription}
            onChange={(e) =>
              handleChange([
                { id: "DispatchDescription", value: e.target.value },
              ])
            }
          />
        </div>
      </div>
      <div className="modal-footer justify-content-center align-items-center">
        <CDBBtn
          type="button"
          color="danger"
          outline
          onClick={() => setPressedButton("closeModal")}
        >
          Cerrar
        </CDBBtn>
        <CDBBtn
          type="button"
          color="success"
          className="mr-auto"
          outline
          onClick={() => setPressedButton("submitModal")}
        >
          Guardar
        </CDBBtn>
      </div>
    </div>
  );
};
